module.exports = __webpack_public_path__ + "static/media/plus-icon.b09ad8c2.svg";